const AWSServiceList = [
  'AWS IAM Access Analyzer',
  'AWS Private Certificate Authority',
  'AWS Certificate Manager',
  'AWS Amplify',
  'Amazon OpenSearch Serverless',
  'Amazon API Gateway Management V2',
  'AWS Application Auto Scaling',
  'AWS Application Transformation Service',
  'AWS App Runner',
  'Amazon AppStream 2.0',
  'AWS AppSync',
  'Application Discovery Arsenal',
  'Amazon Athena',
  'AWS Auto Scaling',
  'Amazon EC2 Auto Scaling',
  'AWS Marketplace Metering Service',
  'AWS Backup storage',
  'AWS Backup',
  'AWS Batch',
  'Amazon Bedrock',
  'Amazon Braket',
  'AWS Cloud9',
  'AWS CloudFormation',
  'Amazon CloudFront',
  'AWS CloudTrail',
  'Amazon CloudWatch',
  'AWS CodeArtifact',
  'AWS CodeBuild',
  'AWS CodeCommit',
  'AWS CodeDeploy secure host commands service',
  'AWS CodeDeploy',
  'Amazon CodeGuru Reviewer',
  'Amazon CodeGuru Security',
  'AWS CodePipeline',
  'AWS CodeStar Connections',
  'AWS CodeStar',
  'Amazon CodeWhisperer',
  'Amazon Cognito Identity',
  'Amazon Cognito User Pools',
  'Amazon Cognito Sync',
  'Amazon Comprehend',
  'Amazon Comprehend Medical',
  'AWS Compute Optimizer',
  'AWS Config',
  'AWS DataSync',
  'Amazon DynamoDB Accelerator (DAX)',
  'AWS DeepRacer',
  'AWS Device Farm',
  'AWS Application Discovery Service',
  'AWS Database Migration Service',
  'Amazon DocumentDB Elastic Clusters',
  'AWS Elastic Disaster Recovery',
  'AWS Directory Service',
  'Amazon DynamoDB',
  'Amazon Elastic Block Store',
  'Amazon EC2 Instance Connect',
  'Amazon EC2',
  'Amazon Message Delivery Service',
  'Amazon Elastic Container Registry',
  'Amazon Elastic Container Service',
  'Amazon Elastic Kubernetes Service',
  'Amazon ElastiCache',
  'AWS Elastic Beanstalk',
  'Amazon Elastic File System',
  'AWS Elastic Load Balancing',
  'Amazon Elastic MapReduce',
  'Amazon Elastic Transcoder',
  'Amazon EMR on EKS (EMR Containers)',
  'Amazon OpenSearch Service',
  'Amazon EventBridge',
  'Amazon API Gateway',
  'Amazon Kinesis Firehose',
  'AWS Fault Injection Service',
  'Amazon FSx',
  'Amazon GameLift Servers',
  'Amazon Location',
  'Amazon S3 Glacier',
  'AWS Global Accelerator',
  'AWS Glue',
  'Amazon Managed Grafana',
  'AWS IoT Greengrass V2',
  'Amazon GroundTruth Labeling',
  'AWS Health APIs and Notifications',
  'AWS HealthLake',
  'AWS Identity and Access Management (IAM)',
  'Amazon Inspector2',
  'Amazon Inspector',
  'Amazon CloudWatch Internet Monitor',
  'AWS IoT',
  'AWS IoT Events',
  'AWS IoT FleetWise',
  'AWS IoT SiteWise',
  'AWS IoT TwinMaker',
  'Apache Kafka APIs for Amazon MSK clusters',
  'Amazon Managed Streaming for Apache Kafka',
  'Amazon Managed Streaming for Kafka Connect',
  'Amazon Kendra',
  'Amazon Kinesis Data Streams',
  'Amazon Kinesis Analytics V2',
  'Amazon Kinesis Video Streams',
  'AWS Key Management Service',
  'AWS Lake Formation',
  'AWS Lambda',
  'AWS Launch Wizard',
  'Amazon Lex V2',
  'AWS License Manager',
  'Amazon Lightsail',
  'Amazon CloudWatch Logs',
  'AWS Mainframe Modernization Service',
  'Amazon Machine Learning',
  'Amazon Macie',
  'Amazon Managed Blockchain',
  'AWS Elemental MediaConnect',
  'AWS Elemental MediaConvert',
  'AWS Elemental MediaLive',
  'AWS Elemental MediaPackage',
  'AWS Elemental MediaStore',
  'AWS Elemental MediaTailor',
  'Amazon MemoryDB',
  'AWS Migration Hub',
  'AWS Application Migration Service',
  'Amazon Pinpoint',
  'AWS Network Firewall',
  'AWS Network Manager',
  'AWS HealthOmics',
  'Amazon Personalize',
  'AWS Performance Insights',
  'Amazon EventBridge Pipes',
  'Amazon Polly',
  'AWS Price List',
  'Amazon Q',
  'Amazon QuickSight',
  'AWS Resource Access Manager (RAM)',
  'Amazon RDS Data API',
  'Amazon RDS IAM Authentication',
  'Amazon RDS',
  'Amazon Redshift Data API',
  'Amazon Redshift Serverless',
  'Amazon Redshift',
  'AWS Migration Hub Refactor Spaces',
  'Amazon Rekognition',
  'Tag Editor',
  'AWS Resource Groups',
  'AWS Identity and Access Management Roles Anywhere',
  'Amazon Route 53 Recovery Controls',
  'Amazon Route 53 Recovery Readiness',
  'Amazon Route 53',
  'Amazon Route 53 Domains',
  'Amazon Route 53 Resolver',
  'AWS CloudWatch RUM',
  'Amazon S3 Object Lambda',
  'Amazon S3',
  'Amazon SageMaker with MLflow',
  'Amazon SageMaker',
  'Amazon EventBridge Schemas',
  'Amazon SimpleDB',
  'AWS Secrets Manager',
  'AWS Security Hub',
  'AWS Serverless Application Repository',
  'AWS Service Catalog',
  'AWS Cloud Map',
  'AWS Microservice Extractor for .NET',
  'Service Quotas',
  'Amazon Pinpoint Email Service',
  'AWS Shield',
  'Amazon Pinpoint SMS and Voice Service',
  'Amazon SNS',
  'AWS SQL Workbench',
  'Amazon SQS',
  'AWS Systems Manager GUI Connect',
  'AWS Systems Manager Incident Manager',
  'AWS Systems Manager',
  'Amazon Message Gateway Service',
  'AWS Step Functions',
  'AWS Storage Gateway',
  'AWS Security Token Service',
  'AWS Support',
  'Amazon CloudWatch Synthetics',
  'Amazon Resource Group Tagging API',
  'Amazon Textract',
  'Amazon Timestream',
  'AWS Tiros',
  'Amazon Transcribe',
  'Amazon Translate',
  'AWS Trusted Advisor',
  'Amazon VPC Lattice',
  'AWS WAF V2',
  'AWS Well-Architected Tool',
  'AWS X-Ray',
];

const shortName = (service: string): string => {
  if (/.*\(\w{2,3}\)/.test(service)) {
    return service.split(/\(/g)
      .reverse()[0]
      .split(')')[0];
  }
  if (service.startsWith('Amazon ')) {
    return service.replace('Amazon ', '');
  }
  if (service.startsWith('AWS ')) {
    return service.replace('AWS ', '');
  }
  return service;
};

// noinspection JSUnusedGlobalSymbols
export const AwsServices = {
  list: AWSServiceList,
  shortName,
};
